module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fff00873b289b4bf62356568b8852ff0.gif";